export default "__VITE_ASSET__W2_Z3HkI__"